import axios from "axios";
import Region from "@/models/region";
import { CategoryTag } from "@/models/tag";
// @ts-ignore
import { JsonApiDataStore } from "../../../node_modules/jsonapi-datastore";
import { configService } from "../index";
import Relationship from "@/models/relationship";
import Country from "@/models/country";
import NumericPrefix from "@/models/numeric-prefix";

const utilitiesDataStore = new JsonApiDataStore();

export default {
  getRegions(): Promise<any> {
    return axios
      .get(`${configService.utilities}/regions`)
      .then((response: any): any => {
        utilitiesDataStore.reset();
        utilitiesDataStore.sync(response.data);
        return utilitiesDataStore
          .findAll("region")
          .map((region: Region): Region => new Region().deserialize(region));
      });
  },
  getRegionsV2(): Promise<any> {
    return axios
      .get(`${configService.regions}`)
      .then((response: any): any => {
        return response.data.data.map((region: Region): Region => new Region().deserialize(region));
      });
  },
  getAllTags(): Promise<any> {
    return axios
      .get(`${configService.apiEndpoint}/tag_categories`)
      .then((response: any): any => {
        utilitiesDataStore.reset();
        utilitiesDataStore.sync(response.data);
        return utilitiesDataStore
          .findAll("category")
          .map(
            (categoryTag: CategoryTag): CategoryTag =>
              new CategoryTag().deserialize(categoryTag)
          );
      });
  },
  getCategoryTags(id: number): Promise<any> {
    return axios
      .get(`${configService.apiEndpoint}/tag_categories/${id}`)
      .then((response: any): any => {
        utilitiesDataStore.reset();
        utilitiesDataStore.sync(response.data);
        return utilitiesDataStore
          .findAll("region")
          .map((region: Region): Region => new Region().deserialize(region));
      });
  },
  editProfile(type: any, data: any, rel?: Relationship[]): any {
    let dataToUpdate: any = {};
    for (const prop in data) {
      if (prop != "place_attributes") {
        dataToUpdate[prop] = data[prop];
      } else {
        for (const key in data[prop]) {
          if (key != "id") {
            dataToUpdate[key] = data[prop][key];
          }
        }
      }
    }
    return axios.put(configService.profile, dataToUpdate);
  },

  getCountries(): Promise<any> {
    return axios.get(configService.countryApi)
        .then((response: any): any => {
          return response.data.map((country: Country): Country => new Country().deserialize(country));
    });
  },

  getNumericCodes(): Promise<any> {
    return axios.get(configService.countryApi).then((response: any): any => {
      let numericPrefixes: NumericPrefix[] = [];
      response.data.forEach((country: any) => {
        const callingCodes = country.callingCodes as string[];
        for (const prefixCode of callingCodes) {
          const alreadyInLisIndex = numericPrefixes.findIndex(numericPrefix => numericPrefix.phonePrefix === prefixCode);
          if (alreadyInLisIndex >= 0) {
            numericPrefixes[alreadyInLisIndex].isoCode2.push(country.alpha2Code);
            numericPrefixes[alreadyInLisIndex].isoCode3.push(country.alpha3Code);
          } else {
            numericPrefixes.push({
              phonePrefix: prefixCode,
              isoCode2: [country.alpha2Code],
              isoCode3: [country.alpha3Code]
            } as NumericPrefix)
          }
        }
      });

      return numericPrefixes
          .sort((prefixA: NumericPrefix, prefixB: NumericPrefix) => {
            const numPrefixA = Number.parseInt(prefixA.phonePrefix);
            const numPrefixB = Number.parseInt(prefixB.phonePrefix);
            return numPrefixA - numPrefixB;
          })
    });
  }
};
